import React from 'react';
import './footer.scss';
import iplogo from '../../images/footer/iplog.png';
import { Link } from 'react-router-dom';
import { TiSocialFacebookCircular } from 'react-icons/ti';
import paypalPaymentMethods from '../../images/products/PayPal-payment.png';

/**
 * Footer Component
 */
function Footer(props) {

   return (
      <footer id={props.isThiner ? 'show-footer' : ''} className="container-fluid footer">
         <div className="row inner-div justify-content-between">
            
            
            <div className="f-first-row">
            <div className="f-links d-flex flex-row">
               <div className="f-links-in d-flex flex-column">
                  <Link to="/">Home</Link>
                  <Link to="/products">Products</Link>
                  <Link to="/cart">Cart</Link>
               </div>

               <div className="f-links-in d-flex flex-column">
                  <Link to="/about-us">About Us</Link>
                  <Link to="/contact">Contact</Link>
               </div>
            </div>
            <div className="f-paypal">
               <img src={paypalPaymentMethods} alt="PayPal Payment Accepted" />
            </div>
            </div>

            

            <div className="f-logo d-flex flex-column flex-basis-100">
               <div className="f-ip d-flex align-items-start justify-content-end order-2 order-md-1">
                  <div>
                     <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/InheritancePublications/" id="facebook-icon"><TiSocialFacebookCircular /></a>
                  </div>
                  <img src={iplogo} alt="IP logo" />
               </div>
               <div className="copyright-development text-right order-1 order-md-2">
                  <p>&copy; Inheritance publications Inc. 2020</p>
                  <p>Design and developed by <a href="https://brunoreactdeveloper.web.app/" target="_blank" rel="noopener noreferrer" className="font-weight-bold">Bruno Lima</a></p>
               </div>
            </div>
         </div>
      </footer>
   )
}

export default Footer;